import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GET_AGENT } from '../../../../../redux/settings/id8/id8SettingsActions';
import { clearNotificationStatus, setNotificationStatus } from '../../../../../redux/notifier/notifierReducer';

function SettingsId8NotificationBarController() {
  const dispatch = useDispatch();

  const loadingActions = useSelector((state) => state.global.loadingActions);

  const getAgentActionState = loadingActions[GET_AGENT];

  useEffect(() => {
    if (getAgentActionState) {
      dispatch(setNotificationStatus('loadingAgentData'));
    } else {
      dispatch(clearNotificationStatus());
    }
  }, [dispatch, getAgentActionState]);

  return null;
}

export default SettingsId8NotificationBarController;
